import { Injectable } from '@angular/core';

@Injectable()
export class NumberValidatorService {

    public isNumber(possibleNumber:any):boolean{
        return !(possibleNumber instanceof Date) && !isNaN(possibleNumber);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/validation/number-validator.service.ts